import React from 'react';
import PropTypes from 'prop-types';

import Table from './components/Table'
import TableFilters from './components/TableFilters'
import TablePagination from './components/TablePagination'
import './DataTable.scss'

// TODO: add options to configure filters 
// TODO: (MAYBE) make per page, pagination, sorting, etc optional?

export default class DataTable extends React.Component {

	static propTypes = {
		// tableConfig: PropTypes.shape({}).isRequired,
		columns: PropTypes.array.isRequired,
		data: PropTypes.array,
		filters: PropTypes.array,
		// change handler
		onChangeSearch: PropTypes.func,
		onChangeFilter: PropTypes.func,
		// sorting
		onChangeSort: PropTypes.func,
		// pagination
		pagination: PropTypes.object,
		onChangePage: PropTypes.func,
		onChangePerPage: PropTypes.func,
		// TODO: add all other props used
	};

	// Lifecycle

	constructor(props) {
		super(props);
		// this.removeResourceSelectQuery();
	}

	componentDidMount() {
		this.fixInvalidPageNumber();
	}

	componentDidUpdate() {
		this.fixInvalidPageNumber();
	}

	// removeResourceSelectQuery() {
	// 	const { filters, currentQuery, onChangeFilter } = this.props;
	// 	console.log(filters, currentQuery);

	// 	const newQuery = {
	// 		...currentQuery,
	// 		client: null,
	// 		status: 1,
	// 	}

	// 	console.log(newQuery);
	// 	onChangeFilter({
	// 		status: 1,
	// 		client: null,
	// 	})

	// }

	
	fixInvalidPageNumber() {
		// set page to 1 if current page is invalid
		const { onChangePage, pagination, page } = this.props;

		if(pagination && pagination.totalPages && page > pagination.totalPages) {
			onChangePage(1);
		}
	}

	// Render
	
	render() {

		const {
			data, 
			columns,
			currentQuery,
			filters,
			pagination, 
			sortBy,
			sortDir,
			rowLinks,
			onChangePerPage, 
			onChangePage,
			onChangeSearch,
			onChangeSort,
			onChangeFilter,
		} = this.props;

		return (
			<div className="DataTable">
				
				{
					filters &&
					<TableFilters  
						filters={filters}
						currentQuery={currentQuery}
						onChangeSearch={onChangeSearch}
						onChangeFilter={onChangeFilter}
					/>
				}

				<Table 
					data={data}
					columns={columns}
					onChangeSort={onChangeSort}
					sortBy={sortBy}
					sortDir={sortDir}
					rowLinks={rowLinks}
				/>

				{
					pagination && 
					<TablePagination 
						pagination={pagination}
						onChangePage={onChangePage}
						onChangePerPage={onChangePerPage}
					/> 
				}
			</div>
		)
	}



}


// WEBPACK FOOTER //
// ./src/components/DataTable/DataTable.jsx